export enum Events {
    TRIP_NOTIFICATIONS = 'tripNotification',
    NOTIFICATION = 'notification'
}
